import { get, create, remove } from './Provider';
import { ITask } from './model/ITask';
import { ITaskCreate } from './model/ITaskCreate';

const RESOURCE = 'public/tasks';

export const Task = {
  get: (id: string) => get<ITask>(RESOURCE, id),
  create: async (task: ITaskCreate): Promise<string> => (await create(RESOURCE, task)).json(),
  delete: (id: string) => remove(RESOURCE, id)
}